module.exports = __webpack_public_path__ + "static/media/p208gtel.ad0b6810.jpg";